var $fa252f2012a3ab42$exports = {};
$fa252f2012a3ab42$exports = {
    "pending": `v teku`
};


export {$fa252f2012a3ab42$exports as default};
//# sourceMappingURL=sl-SI.mjs.map
